import { render, staticRenderFns } from "./notice-edit.vue?vue&type=template&id=d479aee0&scoped=true"
import script from "./notice-edit.vue?vue&type=script&lang=js"
export * from "./notice-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d479aee0",
  null
  
)

export default component.exports